export const isValidPhone = (v: string) =>
  /^\+[1-9]\d{7,14}$/.test((v || "").trim());
